import React from "react";
import { message } from "antd";

import { DeleteIcon } from "src/components";
import { compose } from "src/helpers";
import { withDeleteMeme } from "src/modules/meme/operations";
import { captureException } from "@sentry/react";

const DeleteView = (props) => {
    const { deleteMeme, id } = props;

    const handleDelete = async () => {
        try {
            await deleteMeme(id);
            message.success("Deleted!");
        } catch (err) {
            captureException(err)
            message.error("Failed!");
        }
    };

    return <DeleteIcon {...props} onConfirm={handleDelete} />;
};

export default compose(withDeleteMeme)(DeleteView);
